import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=07b6d679&scoped=true&"
var script = {}
import style0 from "./Index.vue?vue&type=style&index=0&id=07b6d679&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b6d679",
  null
  
)

export default component.exports